var _regeneratorRuntime = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * Dependencies
 *
 * TODO
 * - switch between Node.js webcrypto package and browser implementation
 */
// const base64url = require('base64url')
var supportedAlgorithms = require('../algorithms');

var _require = require('../errors'),
    NotSupportedError = _require.NotSupportedError;
/**
 * JWA
 * https://tools.ietf.org/html/rfc7518
 */


var JWA = /*#__PURE__*/function () {
  "use strict";

  function JWA() {
    _classCallCheck(this, JWA);
  }

  _createClass(JWA, null, [{
    key: "sign",

    /**
     * Sign
     *
     * @description
     * Create a digital signature.
     *
     * @param {string} alg
     * @param {CryptoKey} key
     * @param {string|Buffer} data
     *
     * @return {Promise}
     */
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(alg, key, data) {
        var normalizedAlgorithm;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // normalize the algorithm
                normalizedAlgorithm = supportedAlgorithms.normalize('sign', alg); // validate algorithm is supported

                if (!(normalizedAlgorithm instanceof Error)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Promise.reject(new NotSupportedError(alg)));

              case 3:
                return _context.abrupt("return", normalizedAlgorithm.sign(key, data));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sign(_x, _x2, _x3) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
    /**
     * Verify
     *
     * @description
     * Verify a digital signature.
     *
     * @param {string} alg
     * @param {CryptoKey} privateKey
     * @param {string|Buffer} signature
     * @param {string|Buffer} data
     *
     * @return {Promise}
     */

  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(alg, key, signature, data) {
        var normalizedAlgorithm;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                normalizedAlgorithm = supportedAlgorithms.normalize('verify', alg);

                if (!(normalizedAlgorithm instanceof Error)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", Promise.reject(new NotSupportedError(alg)));

              case 3:
                return _context2.abrupt("return", normalizedAlgorithm.verify(key, signature, data));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function verify(_x4, _x5, _x6, _x7) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
    /**
     * Encrypt
     */

    /**
     * Decrypt
     */

    /**
     * Import
     */

  }, {
    key: "importKey",
    value: function () {
      var _importKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var normalizedAlgorithm;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                normalizedAlgorithm = supportedAlgorithms.normalize('importKey', key.alg);
                return _context3.abrupt("return", normalizedAlgorithm.importKey(key));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function importKey(_x8) {
        return _importKey.apply(this, arguments);
      }

      return importKey;
    }()
  }]);

  return JWA;
}();
/**
 * Export
 */


module.exports = JWA;